"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CONFIGURED_INPUT_SHORT = exports.CONFIGURED_INPUT_OK = exports.CONFIGURED_INPUT_LONG = exports.CONFIGURED_INPUT_ERROR = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));

var _VerifiedUserOutlined = _interopRequireDefault(require("@material-ui/icons/VerifiedUserOutlined"));

var _useOurTranslation = require("../../utils/useOurTranslation");

var _InputAdornment = _interopRequireDefault(require("@material-ui/core/InputAdornment"));

var _OutlinedInput = _interopRequireDefault(require("@material-ui/core/OutlinedInput"));

var _InputLabel = _interopRequireDefault(require("@material-ui/core/InputLabel"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _IntroText = _interopRequireDefault(require("../IntroText"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ProfileProvider = require("../../provider/ProfileProvider");

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var CONFIGURED_INPUT_OK = 0;
exports.CONFIGURED_INPUT_OK = CONFIGURED_INPUT_OK;
var CONFIGURED_INPUT_SHORT = 1;
exports.CONFIGURED_INPUT_SHORT = CONFIGURED_INPUT_SHORT;
var CONFIGURED_INPUT_LONG = 2;
exports.CONFIGURED_INPUT_LONG = CONFIGURED_INPUT_LONG;
var CONFIGURED_INPUT_ERROR = 3;
exports.CONFIGURED_INPUT_ERROR = CONFIGURED_INPUT_ERROR;

var ConfiguredInput = function ConfiguredInput(_ref) {
  var config = _ref.config,
      _ref$errorCode = _ref.errorCode,
      errorCode = _ref$errorCode === void 0 ? 3 : _ref$errorCode,
      validateType = _ref.validateType,
      handleChange = _ref.handleChange,
      dataProcessing = _ref.dataProcessing,
      handleTextboxChange = _ref.handleTextboxChange;
  var t = (0, _useOurTranslation.useComponentTranslation)(config);
  var context = (0, _react.useContext)(_ProfileProvider.ProfileContext);
  (0, _react.useEffect)(function () {
    var stopTabFunction = function stopTabFunction(e) {
      if (e.keyCode === 9 && !validateType(config.inputType)(context[config.valueName].value)) {
        e.preventDefault();
      }
    };

    window.addEventListener('keydown', stopTabFunction);
    return function () {
      return window.removeEventListener('keydown', stopTabFunction);
    };
  }, [config.inputType, config.valueName, context, validateType]);

  var errorHint = function errorHint(error) {
    switch (errorCode) {
      case CONFIGURED_INPUT_SHORT:
        return t(config.translations.helperMin);

      case CONFIGURED_INPUT_LONG:
        return t(config.translations.helperMax);

      case CONFIGURED_INPUT_ERROR:
      default:
        return t(config.translations.helper);
    }
  };

  var inputInvalid = errorCode !== CONFIGURED_INPUT_OK;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_IntroText.default, {
      headline: t(config.translations.text),
      hintComponent: config.hintComponent,
      text: t(config.translations.hint),
      textColor: "light"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: _styleModule.default.textField,
      children: [config.selectBox && /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormControl.default, {
        variant: "outlined",
        fullWidth: true,
        className: _styleModule.default.select,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormControl.default, {
          variant: "outlined",
          fullWidth: true,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextField.default, {
            select: true,
            autoComplete: "on",
            variant: "outlined",
            className: _styleModule.default.select,
            SelectProps: {
              native: true
            },
            onChange: handleTextboxChange,
            id: "".concat(config.selectBox.valueName, "-select"),
            value: context[config.selectBox.valueName].value,
            label: t(config.translations.defaultSelectorText),
            children: Object.entries(config.selectBox.options).map(function (_ref2) {
              var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
                  key = _ref3[0],
                  value = _ref3[1];

              return /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
                value: key,
                children: t(String(value))
              }, key);
            })
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FormControl.default, {
        fullWidth: true,
        variant: "outlined",
        className: (0, _classnames.default)((0, _defineProperty2.default)({}, _styleModule.default.withSelect, !!config.selectBox)),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_InputLabel.default, {
          className: _styleModule.default.label,
          htmlFor: "".concat(config.valueName, "-input"),
          children: t(config.translations.inputField)
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_OutlinedInput.default, {
          fullWidth: true,
          autoComplete: "on",
          error: inputInvalid,
          onBlur: dataProcessing,
          name: config.valueName,
          onChange: handleChange,
          id: "".concat(config.valueName, "-input"),
          type: config.inputType || 'text',
          defaultValue: context[config.valueName].value,
          endAdornment: /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputAdornment.default, {
            position: "end",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_VerifiedUserOutlined.default, {
              color: "primary",
              className: _styleModule.default.icon
            })
          })
        }), inputInvalid && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: _styleModule.default.validationHelper,
          children: errorHint(errorCode)
        })]
      })]
    })]
  });
};

var _default = /*#__PURE__*/(0, _react.memo)(ConfiguredInput);

exports.default = _default;